export default __webpack_public_path__ + "static/media/invoiceurl.0f4b67b5.svg";